import { CDNImage } from '~/components/business/CDNImage'

export const RankNo: React.FC<{
  no: number
}> = ({ no }) => {
  return (
    <>
      {no <= 3 ? (
        <CDNImage
          src={`/images/rank/no_${no}.png`}
          alt=""
          className="w-12 h-12"
        />
      ) : (
        <div className="flex items-center justify-center w-12 h-12">
          <div className="py-1.5 px-2 text-neutral-400 bg-neutral-200 rounded text-[18px] leading-[20px] font-semibold">
            {no}
          </div>
        </div>
      )}
    </>
  )
}
